import script from "./headerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./headerComponent.vue?vue&type=script&setup=true&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=a967f480&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a967f480"]])

export default __exports__